import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { Form, Modal } from "reactstrap";
import Swal from 'sweetalert2';
import { Controller, useForm } from "react-hook-form";

import API from '../../API';
import { DateFormat, DateFormatJSON, NumberFormat, CleanMobile, TimeFormat, DateThaiFormat, RootURL } from '../../Utils/Function';
import { SearchSubDistrict, SearchCustomer } from '../../Utils/Search';
import { QuotationType, QuotationTypeName } from '../../Utils/Status';
import { ProductView } from '..';
import parse from 'html-react-parser'
import moment from 'moment';
import AsyncSelect from 'react-select/async';

import { ThaiDatePicker } from "thaidatepicker-react";
import "react-datepicker/dist/react-datepicker.css";
import NewWindow from 'react-new-window'
import PromotionItem from '../Promotion/PromotionItem';
import QuotationEventCreate from './QuotationEventCreate';
import QuotationItem from './QuotationItem';

const QuotationCreate = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();

    const [_Step, setStep] = useState(1);
    const [ModalState, setModalState] = useState(false);

    const [_Customer, setCustomer] = useState(null);
    const [_CustomerSearch, setCustomerSearch] = useState('');
    const [_CustomerList, setCustomerList] = useState([]);
    const [_CustomerLoading, setCustomerLoading] = useState(false);
    const [_EventList, setEventList] = useState([]);
    const [_EventSave, setEventSave] = useState([]);
    const [_PackageItemSelectIndex, setPackageItemSelectIndex] = useState(undefined);

    const _EventCreateRef = useRef();

    const [_ItemSave, setItemSave] = useState([]);
    const [_PromoitionList, setPromotionList] = useState([]);
    const [_TotalAmount, setTotalAmount] = useState(0);
    const [_TotalDiscount, setTotalDiscount] = useState(0);
    const [AccountType, setAccountType] = useState(0);
    const [_Invoice,setInvoice] = useState(0);

    const [_QuotationRemarkList, setQuotationRemarkList] = useState([]);
    const [_QuotationRemarkID, setQuotationRemarkID] = useState(0);
    const [_QuotationRemark, setQuotationRemark] = useState(null);

    const _ItemCreateRef = useRef();
    const _PromotionItemRef = useRef();

    useEffect(() => {
        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
        Show(Customer) {
            _ClearValue();
            setModalState(true);
            setCustomerLoading(false);
        }
    }));

    const _ClearValue = () => {
        setStep(1);
        reset();

        setCustomer(null);
        setCustomerList([]);
        setCustomerSearch('');
        setItemSave([]);
        setEventList([]);
        setEventSave([]);

        setQuotationRemarkList([]);
        setQuotationRemarkID(0);
        setQuotationRemark(null);
        setInvoice(0);
    }

    const _CloseModel = () => {
        setModalState(false);
        if (props.callback != undefined) {
            try { props.callback(); } catch (e) { }
        }
    }
    const _NextStep = () => {
        if (_Step === 1) {
            if (_Customer == null) {
                Swal.fire({ icon: 'error', title: 'โปรดระบุลูกค้า' });
                return;
            }
            _LoadEventList(_Customer.CustomerID);

            setStep(2);
        } else if (_Step === 2) {
            console.log(_EventSave);
            _LoadQuotationRemark();
            setStep(3);
        }
    };

    const _PrevStep = () => {
        if (_Step === 3) {
            _LoadEventList(_Customer.CustomerID);
        }
        if (_Step > 1) setStep(_Step - 1);

    };


    const _UpdateCustomer = (e) => {
        setCustomer(e);
        //window.setTimeout(()=>{_NextStep();},500);
    }

    const _CustomerInfo = () => {
        if (_Customer == null) return;
        window.open(RootURL() + '/Customer/Info/' + _Customer.CustomerId, '_blank');
    }

    const _LoadEventList = (CustomerID) => {
        setEventList([]);
        API({ method: 'get', url: '/Quotation/Event/' + CustomerID + '/Customer' }).then(res => {
            if (!res.data.status) return;
            setEventList(res.data.data || []);
        }).catch(() => { });
    };

    const _FormatEventDate = (eventDate) => {
        const m = new moment(eventDate);
        if (!m.isValid()) return '-';
        const d = m.toDate();
        return DateThaiFormat(d, false);
    };

    const _FormatEventTime = (datetimeStr) => {
        if (!datetimeStr) return '-';
        return moment(datetimeStr).format('HH:mm');
    };

    const _ToggleEventSelect = (evt) => {
        const existing = _EventSave.find(e => e.CustomerEventId === evt.CustomerEventId);
        if (existing) {
            const itemExists = _ItemSave.find(e=> e.CustomerEventId === evt.CustomerEventId);
            if(itemExists){
                Swal.fire({icon:'warning', title:'ไม่สามารถยกเลิกได้', text:'มีรายการสินค้าที่เชื่อมกับวันจัดงานนี้'});
                return;
            }
            setEventSave(prev => prev.filter(e => e.CustomerEventId !== evt.CustomerEventId));
        } else {
            const edRaw = evt.eventDate ?? evt.EventDate;
            let dateStr, eventDateObj;
            if (edRaw && typeof edRaw === 'object' && edRaw.year !== undefined) {
                dateStr = edRaw.year + '-' + String(edRaw.month).padStart(2, '0') + '-' + String(edRaw.day).padStart(2, '0');
                eventDateObj = new Date(edRaw.year, edRaw.month - 1, edRaw.day);
            } else {
                dateStr = moment(edRaw).format('YYYY-MM-DD');
                eventDateObj = moment(edRaw).toDate();
            }
            const startRaw = evt.eventStart ?? evt.EventStart;
            const startStr = startRaw ? moment(startRaw).format('HH:mm') : null;
            setEventSave(prev => [...prev, evt]);
        }
    };
    const _DeleteEvent = (evt) => {
        const existing = _EventSave.find(e => e.CustomerEventId === evt.CustomerEventId);
        if (existing) {
            const itemExists = _ItemSave.find(e=> e.CustomerEventId === evt.CustomerEventId);
            if(itemExists){
                Swal.fire({icon:'warning', title:'ไม่สามารถลบได้', text:'มีรายการสินค้าที่เชื่อมกับวันจัดงานนี้'});
                return;
            }
        }

        Swal.fire({
            icon: 'warning',
            title: 'ต้องการลบ หรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'ลบ',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) return;
            API({ method: 'delete', url: '/Quotation/Event/' + evt.CustomerEventId }).then(res => {
                if (!res.data.status) {
                    Swal.fire({ icon: 'error', title: res.data.message });
                    return;
                }
                _LoadEventList(_Customer.CustomerID);
            }).catch(res => {
                if (res.response.data != undefined) {
                    Swal.fire({ icon: 'error', title: res.code, text: res.response.data.message });
                } else {
                    Swal.fire({ icon: 'error', title: 'การเชื่อมต่อผิดพลาด', text: res.message + ' [' + res.code + ']' });
                }
            });
        });
    }
    const _LoadQuotationRemark = async () => {
        setQuotationRemarkList([]);
        API({ method: "get", url: '/Search/QuotationRemark/List' }).then(res => {
            if (res.data.status) {
                setQuotationRemarkList(res.data.data);
            }
        }).catch(res => {
            Swal.fire({
                icon: 'error',
                title: 'การเชื่อมต่อผิดพลาด',
                text: res.message + ' [' + res.code + ']',
            });
        });
    }

    const _NewItem = () => {
        if (_ItemCreateRef.current) {
            const ItemSave = [..._ItemSave];
            console.log(ItemSave.length);
            _ItemCreateRef.current.Show(_Customer, _EventSave, ItemSave.length);
        }

    }
    const _PackageChangeClick = (d) => {
        const _Items = [..._ItemSave];
        let _ItemN = [];
        let _SelectObj = undefined;
        _Items.find((v, i) => { if (_PackageItemSelectIndex === i) _SelectObj = v; });
        let _curIndex = 0;
        if (d === 1) _curIndex = _PackageItemSelectIndex + 1;
        if (d === 2) _curIndex = _PackageItemSelectIndex - 1;
        if (_curIndex >= _Items.length) return;
        if (_curIndex < 0) _curIndex = 0;
        let _Update = false;
        _Items.find((v, i) => {
            if (d === 2 && _curIndex === i) {
                _SelectObj.LineNumber = _ItemN.length + 1;
                _ItemN.push(_SelectObj);
                _Update = true;
            }
            if (i != _PackageItemSelectIndex) {
                let _Obj = v;
                _Obj.LineNumber = _ItemN.length + 1;
                _ItemN.push(_Obj);
            }
            if (d === 1 && _curIndex === i) {
                _SelectObj.LineNumber = _ItemN.length + 1;
                _ItemN.push(_SelectObj);
                _Update = true;
            }
        });
        if (_Update === false) {
            _SelectObj.LineNumber = _ItemN.length + 1;
            _ItemN.push(_SelectObj);
        }
        setPackageItemSelectIndex(_curIndex);
        setItemSave(_ItemN);
    }
    const _PackageItemClick = (Index) => {
        if (Index === _PackageItemSelectIndex)
            setPackageItemSelectIndex(undefined);
        else
            setPackageItemSelectIndex(Index);
    }

    const _ItemUpdate = (Index, ItemObj) => {
        const _Item = [..._ItemSave];
        let _ItemN = [];
        _Item.find((e, i) => {
            if (Index === i) {
                if (ItemObj.FOC) {
                    ItemObj.DiscountAmount = ItemObj.Quantity * ItemObj.UnitPrice;
                    ItemObj.TotalAmount = ItemObj.Quantity * ItemObj.UnitPrice;
                } else {
                    ItemObj.TotalAmount = ItemObj.Quantity * ItemObj.UnitPrice;
                    ItemObj.DiscountAmount = 0;
                }
                _ItemN.push(ItemObj);
            } else {
                _ItemN.push(e);
            }
        });
        _ItemTotalCal(_ItemN);
    }

    const _ItemDelete = (Index) => {
        const _Item = [..._ItemSave];
        let _ItemN = [];
        let _i = 0;
        _Item.find((e, i) => {
            if (Index != i) {
                _i++;
                e.LineNumber = _i;
                _ItemN.push(e);
            }
        });
        _ItemTotalCal(_ItemN);
    }
    const _ItemPrice = (Index, ItemObj) => {

    }
    const _ItemInfo = (ItemObj) => {

    }


    const _PromotionItem = () => {
        _PromotionItemRef.current?.NewItem();
    }

    const _PromotionNewItem = (v) => {
        let _refAR = [..._PromoitionList];
        _refAR.push(v);
        setPromotionList(_refAR);
        _ItemTotalCal(undefined, _refAR);
    }
    const _PromotionDelete = (index) => {
        const _refAR = [..._PromoitionList];
        let _newAR = [];
        _refAR.find((v, i) => { if (i != index) _newAR.push(v); });
        setPromotionList([..._newAR]);
        _ItemTotalCal(undefined, _newAR);
    }

    const _ItemTotalCal = (ItemList, PromotionList) => {
        let _Total = 0;
        let _Discount = 0;
        if (ItemList === undefined) ItemList = _ItemSave;
        if (PromotionList === undefined) PromotionList = _PromoitionList;
        ItemList.find((e, i) => {
            _Total += e.TotalAmount;
            _Discount += e.DiscountAmount;
        });
        PromotionList.find((e, i) => {
            if (e.DiscountType === 3 || e.DiscountType === 4) return;
            _Discount += e.DiscountValue;
        });
        setTotalAmount(_Total);
        setTotalDiscount(_Discount);
        setItemSave(ItemList);
    }

    const _Save = async () => {
        if (_Customer === null || _Customer === undefined) {
            Swal.fire({ icon: 'error', title: 'โปรดระบุลูกค้า' });
            return;
        }


        if (_EventSave.length === 0) {
            Swal.fire({ icon: 'error', title: 'โปรดเลือกวันจัดงาน' });
            return;
        }

        const _EventObjList = _EventSave.map(ev => {
            return ev.CustomerEventId ?? ev.CustomerEventId;
        });

        const _ItemSaveList = [..._ItemSave];
        if (_ItemSaveList.length == 0) {
            Swal.fire({ icon: 'error', title: 'โปรดตรวจสอบรายการ' });
            return;
        }
        let _TotalAmount = 0;
        _ItemSaveList.find((v, i) => { _TotalAmount += v.TotalAmount; });
        if (_TotalAmount === 0) {
            Swal.fire({ icon: 'error', title: 'โปรดตรวจสอบรายการ' });
            return;
        }
        let _reqObj = {
            CustomerId: _Customer.CustomerID,
            AccountType: AccountType,
            QuotationType: 0,
            Invoice: (_Invoice === 1),
            QuotationEventID: _EventSave[0]?.QuotationEventId || null,
            QuotationRemarkID: _QuotationRemarkID || null,
            Remark: (getValues('Remark') ?? null),
            Note: (getValues('Note') ?? null),
            Events: _EventObjList,
            Items: _ItemSaveList,
            Promotions: []
        };
        _PromoitionList.map((v, i) => { _reqObj.Promotions.push(v.PromotionID); });

        Swal.fire({
            icon: 'warning',
            title: 'ต้องการบันทึก หรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'บันทึก',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) return;
            API({ method: 'post', url: '/Quotation/Save', data: _reqObj }).then(res => {
                if (!res.data.status) {
                    Swal.fire({ icon: 'error', title: res.data.message });
                    return;
                }
                setModalState(false);
                _ClearValue();
                if (props.update != undefined) {
                    try { props.update(res.data.data); } catch (e) { console.log(e); }
                }
            }).catch(res => {
                if (res.response.data != undefined) {
                    Swal.fire({ icon: 'error', title: res.code, text: res.response.data.message });
                } else {
                    Swal.fire({ icon: 'error', title: 'การเชื่อมต่อผิดพลาด', text: res.message + ' [' + res.code + ']' });
                }
            });
        });
    }

    return (
        <>
            <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">สร้างใบเสนอราคา</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { _CloseModel() }}></button>
                </div>

                <div className='modal-body'>
                    {/* Step Indicator */}
                    <div className='row mb-4'>
                        <div className='col-12'>
                            <div className='d-flex align-items-center justify-content-center'>
                                <div className='d-flex flex-column align-items-center' style={{ cursor: _Step > 1 ? 'pointer' : 'default' }} onClick={() => { if (_Step > 1) setStep(1); }}>
                                    <div className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${_Step >= 1 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{ width: '42px', height: '42px', fontSize: '16px' }}>1</div>
                                    <small className={`mt-1 ${_Step === 1 ? 'text-primary fw-bold' : 'text-muted'}`}>ข้อมูลลูกค้า</small>
                                </div>
                                <div style={{ flex: '1', maxWidth: '120px', height: '2px', margin: '0 8px', marginBottom: '20px', background: _Step >= 2 ? '#0d6efd' : '#adb5bd' }}></div>
                                <div className='d-flex flex-column align-items-center' style={{ cursor: _Step > 2 ? 'pointer' : 'default' }} onClick={() => { if (_Step > 2) setStep(2); }}>
                                    <div className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${_Step >= 2 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{ width: '42px', height: '42px', fontSize: '16px' }}>2</div>
                                    <small className={`mt-1 ${_Step === 2 ? 'text-primary fw-bold' : 'text-muted'}`}>สถานที่จัดงาน</small>
                                </div>
                                <div style={{ flex: '1', maxWidth: '120px', height: '2px', margin: '0 8px', marginBottom: '20px', background: _Step >= 3 ? '#0d6efd' : '#adb5bd' }}></div>
                                <div className='d-flex flex-column align-items-center'>
                                    <div className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${_Step >= 3 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{ width: '42px', height: '42px', fontSize: '16px' }}>3</div>
                                    <small className={`mt-1 ${_Step === 3 ? 'text-primary fw-bold' : 'text-muted'}`}>รายการและรายละเอียด</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Form onSubmit={handleSubmit(_Save)} className='row g-3'>

                        {/* ===== STEP 1: Customer Info ===== */}
                        {_Step === 1 && <>
                            <div className='row mt-3 justify-content-end'>
                                <div className='col-md-6'>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control text-center"
                                            placeholder='ค้นหาข้อมูลลูกค้า [ชื่อ / เบอร์โทร ]'
                                            value={_CustomerSearch}
                                            onChange={(e) => setCustomerSearch(e.target.value)}
                                        />
                                        <button className="btn btn-primary" type="button" onClick={() => {
                                            setCustomerList([]);
                                            setCustomerLoading(true);
                                            SearchCustomer(_CustomerSearch).then(res => {
                                                setCustomerLoading(false);
                                                if (res.length === 0) {
                                                    Swal.fire({ icon: 'error', title: 'ไม่พบข้อมูลลูกค้า' });
                                                    return;
                                                } else {
                                                    setCustomerList(res);
                                                }
                                            });
                                        }}>
                                            ค้นหา
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-1'>
                                <div className="col-md-12">
                                    <div className="table">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '30px' }} className="text-center">รหัสลูกค้า</th>
                                                    <th style={{ width: '150px' }} className="text-center">ชื่อลูกค้า</th>
                                                    <th style={{ width: '30px' }} className="text-center">เบอร์โทรศัพท์</th>
                                                    <th style={{ width: '80px' }} className="text-center">ยอดสั่งซื้อที่ผ่านมา</th>
                                                    <th style={{ width: '80px' }} className="text-center">จำนวนใบเสนอราคา</th>
                                                    <th style={{ width: '30px' }} className="text-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {_CustomerLoading == true && (
                                                    <tr><td colSpan={7} className='text-center text-muted py-3'>
                                                        กำลังโหลดข้อมูล โปรดรอสักครู่...
                                                    </td></tr>
                                                )}
                                                {_CustomerList.map((customer, index) => (
                                                    <tr key={customer.CustomerID}>
                                                        <td className="text-center">{customer.CustomerCode}</td>
                                                        <td className="text-left">{customer.Name}</td>
                                                        <td className="text-center">{customer.Mobile}</td>
                                                        <td className="text-center">{customer.TotalOrder}</td>
                                                        <td className="text-center">{customer.QuotationCount}</td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary"
                                                                disabled={customer.CustomerID === _Customer?.CustomerID}
                                                                onClick={() => {
                                                                    _UpdateCustomer(customer);
                                                                }}
                                                            >
                                                                เลือก
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>}
                        {_Step === 2 && <>
                            <div className='row mt-3 justify-content-end'>
                                <div className='col-md-2'>
                                    <div className="input-group">
                                        <button className="btn btn-primary" type="button" onClick={() => {
                                            if (_EventCreateRef.current) {
                                                _EventCreateRef.current.Show(_Customer);
                                            }
                                        }}>
                                            สร้างวันจัดงานใหม่
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-1'>
                                <div className="col-md-12">
                                    <div className="table">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className='text-center' style={{ width: '44px' }}></th>
                                                    <th className='text-center'>วันที่จัดงาน</th>
                                                    <th className='text-center'>เวลาถึงหน้างาน</th>
                                                    <th className='text-center'>เวลาเริ่มบริการ</th>
                                                    <th className='text-center'>เวลาสิ้นสุดบริการ</th>
                                                    <th>สถานที่จัดงาน</th>
                                                    <th className='text-center' style={{ width: '44px' }}>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {_EventList.length === 0 && (
                                                    <tr><td colSpan={7} className='text-center text-muted py-3'>
                                                        {_Customer ? 'ไม่พบวันจัดงาน — กด "สร้างวันจัดงานใหม่" เพื่อเพิ่ม' : 'โปรดเลือกลูกค้าก่อน'}
                                                    </td></tr>
                                                )}
                                                {_EventList.map((v, i) => {
                                                    const isSelected = _EventSave.some(e => e.CustomerEventId === (v.CustomerEventId ?? v.CustomerEventId));
                                                    return (
                                                        <tr key={i}
                                                            className={isSelected ? 'table-primary' : ''}
                                                            style={{ cursor: 'pointer' }}
                                                            >
                                                            <td className='text-center' onClick={(e) => e.stopPropagation()}>
                                                                <input type='checkbox' className='form-check-input'
                                                                    checked={isSelected}
                                                                    onChange={() => _ToggleEventSelect(v)} />
                                                            </td>
                                                            <td className='text-center'>{_FormatEventDate(v.EventDate)}</td>
                                                            <td className='text-center'>{_FormatEventTime(v.standbyTime ?? v.StandbyTime)}</td>
                                                            <td className='text-center'>{_FormatEventTime(v.eventStart ?? v.EventStart)}</td>
                                                            <td className='text-center'>{_FormatEventTime(v.eventEnd ?? v.EventEnd)}</td>
                                                            <td>{v.locationDetail ?? v.LocationDetail ?? '-'}</td>
                                                            <td>
                                                                <button type="button" className='btn btn-sm btn-danger' onClick={(e) => {
                                                                    _DeleteEvent(v);
                                                                }}>
                                                                    ลบ
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>}

                        {_Step === 3 && <>
                            <div className='row mt-4'>
                                <div className='col-md-12'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>ลำดับ</th>
                                                <th className='text-center'>วันที่จัดงาน</th>
                                                <th className='text-center'>รายการ</th>
                                                <th className='text-center'>รายละเอียด</th>
                                                <th className='text-center' style={{ 'width': '100px' }}>จำนวน</th>
                                                <th className='text-center' style={{ 'width': '120px' }}>ราคาต่อหน่วย</th>
                                                <th className='text-center' style={{ 'width': '150px' }}>ราคารวม</th>
                                                <th className='text-end'>
                                                    <div className='btn-group btn-group-sm'>
                                                        <button type="button" className='btn btn-success btn-sm' onClick={() => { _NewItem(); }}>+ เพิ่มรายการ</button>
                                                        <button type="button" className='btn btn-primary btn-sm' onClick={() => { _PackageChangeClick(1) }} disabled={(_PackageItemSelectIndex === undefined ? true : false)}>+</button>
                                                        <button type="button" className='btn btn-primary btn-sm' onClick={() => { _PackageChangeClick(2); }} disabled={(_PackageItemSelectIndex === undefined ? true : false)}>-</button>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {_ItemSave?.map((v, i) => {
                                            console.log(v);
                                            return (<tbody key={i}>
                                                <tr onClick={(e) => { _PackageItemClick(i); }} className={(_PackageItemSelectIndex === i ? 'table-active' : '')}>
                                                    <td className='text-center'>{v.LineNumber}</td>
                                                    <td className='text-center'>
                                                        {v.CustomerEvent ? DateFormat(v.CustomerEvent.EventStart, false) : '-'}
                                                        <br/>
                                                        {v.CustomerEvent ? TimeFormat(v.CustomerEvent.EventStart) : '-'}
                                                        </td>
                                                    <td className='text-left'>{v.Name}</td>
                                                    <td className='text-left'>
                                                        <textarea className='form-control' defaultValue={v.Description} value={v.Description} onChange={(e) => {
                                                            v.Description = e.target?.value;
                                                            _ItemUpdate(i, v);
                                                        }}></textarea>
                                                    </td>
                                                    <td className='text-left'>
                                                        <input type='text' className='form-control text-center' defaultValue={v.Quantity} value={v.Quantity} onChange={(e) => {
                                                            if (isNaN(Number(e.target?.value))) return;
                                                            v.Quantity = Number(e.target?.value);
                                                            _ItemUpdate(i, v);
                                                            _ItemPrice(i, v);
                                                        }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Backspace' || e.key === '.' || e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'Tab') return;
                                                                if (isNaN(Number(e.key))) e.preventDefault();
                                                            }} />
                                                    </td>
                                                    <td className='text-end'>
                                                        <input type='text' className='form-control text-end' defaultValue={v.UnitPrice} value={v.UnitPrice} onChange={(e) => {
                                                            if (isNaN(Number(e.target?.value))) return;
                                                            v.UnitPrice = Number(e.target?.value);
                                                            _ItemUpdate(i, v);
                                                        }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Backspace' || e.key === '.' || e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'Tab') return;
                                                                if (isNaN(Number(e.key))) e.preventDefault();
                                                            }} />
                                                    </td>
                                                    <td className='text-end'>{(v.FOC ? '-' + NumberFormat(v.DiscountAmount) : NumberFormat(v.TotalAmount))}</td>
                                                    <td className='text-end'>
                                                        <div className='btn-group btn-group-sm'>
                                                            <button type="button" className={(v.FOC ? 'btn btn-success' : 'btn btn-secondary')} onClick={() => {
                                                                if (v.FOC) v.FOC = false; else v.FOC = true;
                                                                _ItemUpdate(i, v);
                                                            }}>ของแถม</button>
                                                            <button type="button" className='btn btn-danger' onClick={() => { _ItemDelete(i); }}>ลบ</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr onClick={(e) => { _PackageItemClick(i); }} className={(_PackageItemSelectIndex === i ? 'table-active' : '')}>
                                                    <td></td>
                                                    <td colSpan={6}>
                                                        <textarea className='form-control' readOnly={true} value={(v.Remark != null ? v.Remark : '')}></textarea>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className='btn-group btn-group-sm'>
                                                            <button type='button' className='btn btn-info text-white' onClick={() => { _ItemInfo(v); }}>รายละเอียด</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>);
                                        })}
                                    </table>
                                </div>
                            </div>

                            <div className='row mt-3'>
                                <div className='col-lg-8 table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>รหัสโปรโมชั่น</th>
                                                <th className='text-center'>โปรโมชั่น</th>
                                                <th className='text-center'>รายละเอียด</th>
                                                <th className='text-center'>ส่วนลด</th>
                                                <th className='text-end'>
                                                    <button type="button" className='btn btn-success btn-sm' onClick={() => { _PromotionItem(); }}>+ เพิ่มรายการ</button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {_PromoitionList.map((v, i) => (
                                                <tr key={i}>
                                                    <td className='text-center'>{v.PromotionCode}</td>
                                                    <td className='text-center'>{v.PromotionName}</td>
                                                    <td className='text-center'>{v.Description}</td>
                                                    <td className='text-center'>{v.DiscountValue}</td>
                                                    <td className='text-center'>
                                                        <button type='button' className='btn btn-danger btn-sm' onClick={(e) => { _PromotionDelete(i); }}>ลบ</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='col-lg-4'>
                                    <div className='row mt-3 justify-content-end'>
                                        <div className='col-lg-6 text-end fs-5'>รวมเป็นเงิน</div>
                                        <div className='col-lg-6 text-end'>
                                            <h4 className='fs-5 text-danger'>{NumberFormat(_TotalAmount)}</h4>
                                        </div>
                                    </div>
                                    <div className='row mt-1 justify-content-end'>
                                        <div className='col-lg-6 text-end fs-5'>ส่วนลด</div>
                                        <div className='col-lg-6 text-end'>
                                            <h4 className='fs-5 text-danger'>{NumberFormat(_TotalDiscount)}</h4>
                                        </div>
                                    </div>
                                    <div className='row mt-1 justify-content-end'>
                                        <div className='col-lg-6 text-end fs-5'>รูปแบบการชำระเงิน</div>
                                        <div className='col-lg-6 text-end'>
                                            <h4 className='fs-5'>โอนเงินผ่านธนาคาร</h4>
                                        </div>
                                    </div>
                                    {(AccountType == 1 ? <>
                                        <div className='row mt-1 justify-content-end'>
                                            <div className='col-lg-6 text-end fs-5'>ภาษีมูลค่าเพิ่ม 7%</div>
                                            <div className='col-lg-6 text-end'>
                                                <h4 className='fs-5 text-danger'>{NumberFormat((((_TotalAmount - _TotalDiscount) * 7) / 100))}</h4>
                                            </div>
                                        </div>
                                        <div className='row mt-3 justify-content-end'>
                                            <div className='col-lg-6 text-end'><h4>จำนวนเงินทั้งสิ้น</h4></div>
                                            <div className='col-lg-6 text-end'>
                                                <h4 className='fs-4 text-success'>{NumberFormat((((_TotalAmount - _TotalDiscount) * 7) / 100) + (_TotalAmount - _TotalDiscount))}</h4>
                                            </div>
                                        </div>
                                    </> :
                                        <div className='row mt-3 justify-content-end'>
                                            <div className='col-lg-6 text-end'><h4>จำนวนเงินทั้งสิ้น</h4></div>
                                            <div className='col-lg-6 text-end'>
                                                <h4 className='fs-4 text-success'>{NumberFormat(_TotalAmount - _TotalDiscount)}</h4>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>

                            <div className='row mt-2 mb-2'>
                                <div className='col-md-6'>
                                    <label className="form-label title-label">หมายเหตุ</label>
                                    <select className='form-control' value={_QuotationRemarkID} onChange={(e) => { setQuotationRemarkID(e.target.value); setQuotationRemark(null); _QuotationRemarkList.find((v, i) => { if (v.quotationRemarkId === Number(e.target.value)) { setQuotationRemark(v); } }) }}>
                                        <option value={0} className='text-center'>กรุณาเลือกหมายเหตุ</option>
                                        {_QuotationRemarkList.map((v, i) => (
                                            <option key={i} value={v.quotationRemarkId}>{v.quotationRemarkName}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='col-md-6'>
                                    <label className="form-label title-label">รายละเอียดหมายเหตุ</label>
                                    <textarea className='form-control' readOnly={true} value={(_QuotationRemark != null ? _QuotationRemark.remark : '')}></textarea>
                                </div>
                            </div>

                            <div className='row mt-4'>
                                <div className="col-md-6">
                                    <label className="form-label">หมายเหตุ พิเศษ</label>
                                    <Controller name="Remark" control={control} rules={{ required: false }} render={({ field }) => (
                                        <textarea className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                    )} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Note</label>
                                    <Controller name="Note" control={control} rules={{ required: false }} render={({ field }) => (
                                        <textarea className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                    )} />
                                </div>
                            </div>
                        </>}
                        {/* Navigation */}
                        <div className='row mt-5'>
                            <div className='col-md-12 mt-4 d-flex justify-content-between'>
                                <div>
                                    <button type="button" className='btn btn-danger' onClick={() => { _ClearValue(); }}>ล้างข้อมูล</button>
                                </div>
                                <div className='btn-group btn-group-lg'>
                                    {_Step > 1 && <button type="button" className='btn btn-secondary' onClick={() => { _PrevStep(); }}>ย้อนกลับ</button>}
                                    {_Step < 3 && <button type="button" className='btn btn-primary' onClick={() => { _NextStep(); }}>ถัดไป</button>}
                                    {_Step === 3 && <button type="submit" className='btn btn-success'>บันทึก</button>}
                                </div>
                            </div>
                        </div>

                    </Form>
                </div>
            </Modal>
            <QuotationEventCreate ref={_EventCreateRef} callback={() => {
                _LoadEventList(_Customer.CustomerID);
            }} />
            <QuotationItem ref={_ItemCreateRef} callback={(e) => {
                if (e === undefined || e == null) return;
                let _Item = [..._ItemSave];
                _Item.push(e);
                setItemSave(_Item);
            }} />
            <PromotionItem ref={_PromotionItemRef} newitem={(v) => { _PromotionNewItem(v) }} />

        </>
    );
});

export default React.memo(QuotationCreate)
